import React from 'react';
import ReactDOM from 'react-dom/client';
import "./custom.scss";
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

import "bootstrap/dist/js/bootstrap.bundle";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
        <App />
    </BrowserRouter>

);

